import React from "react";
import { isEmpty } from "lodash";
// enums
import EViewType from "@/cms/enums/EViewType";
// utilities
import SanitizeHTMLString from "@/utilities/SanitizeHTMLString";
// interfaces
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";


type TRMDRTextSanitizer = {

    parentLanguageVersion?: TLanguageVersionList|TLanguageVersionDetail|null;
    languageVersions?: TLanguageVersionList[]|TLanguageVersionDetail[]|null;

    isLoading?:boolean;

}

const RMDRTextSanitizer = ( props:TRMDRTextSanitizer ) => {

    if ( !isEmpty(props.parentLanguageVersion) && props.parentLanguageVersion?.viewType === EViewType.TEXT ) {

        return (
            <div className="ck-content" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(props.parentLanguageVersion.value)}} />
        );

    }

    return null;

}

const Component = React.memo(RMDRTextSanitizer, ( prevProps:TRMDRTextSanitizer, nextProps:TRMDRTextSanitizer ) => {
    console.log("RMDRTextSanitizer.memo", { prevProps, nextProps });
    return !( 
        prevProps.isLoading !== nextProps.isLoading 
        || prevProps.parentLanguageVersion !== nextProps.parentLanguageVersion
    )
});

export default Component;
export type {
    TRMDRTextSanitizer
};